import type { ExternalTableSchema } from '@packages/table-builder';

/** Replaces legacy useGetOfferingPeriod — list data via schema.dataSource.endpoint */
export const esppOfferingPeriodsTable: ExternalTableSchema = {
  metadata: {
    title: 'ESPP Offering Periods',
    entity: 'OfferingPeriod',
  },

  dataSource: {
    endpoint: '/api/award/api/award/offering-period',
    method: 'GET',
    rowIdField: 'offeringPeriodId',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      // Service (EsppOfferingPeriodService) uses Filter; search disabled — suppress table-builder default
      Filter: '',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
    },
    filters: [
      {
        name: 'offeringPeriodStartDate',
        placeholder: 'Start Date',
        type: 'date',
      },
      {
        name: 'offeringPeriodEndDate',
        placeholder: 'End Date',
        type: 'date',
      },
      {
        name: 'offeringPeriodType',
        placeholder: 'Offering Period Type',
        type: 'select',
        options: [
          { label: 'Qualified', value: 'Qualified' },
          { label: 'NonQualified', value: 'NonQualified' },
        ],
      },
      {
        name: 'lookback',
        placeholder: 'Lookback',
        type: 'select',
        options: [
          { label: 'Yes', value: 'true' },
          { label: 'No', value: 'false' },
        ],
      },
      {
        name: 'planIds',
        placeholder: 'Plan Name',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/award/api/app/plan/plan-options',
          labelField: 'name',
          valueField: 'id',
        },
      },
    ],
  },

  columns: [
    { field: 'name', header: 'Name', type: 'text', width: 300 },
    { field: 'planName', header: 'Plan Name', type: 'text', width: 300 },
    {
      field: 'offeringPeriodStartDate',
      header: 'Start Date',
      type: 'date',
      width: 300,
      align: 'center',
    },
    {
      field: 'offeringPeriodEndDate',
      header: 'End Date',
      type: 'date',
      width: 300,
      align: 'center',
    },
    {
      field: 'fmvAtStart',
      header: 'Start Price',
      type: 'currency',
      width: 300,
      align: 'center',
    },
    {
      field: 'discountPercent',
      header: 'Discount',
      type: 'percentage',
      width: 300,
      align: 'center',
    },
    {
      field: 'offeringPeriodType',
      header: 'Type',
      type: 'badge',
      width: 300,
      align: 'center',
      badge: {
        statusMap: {
          Qualified: 'success',
          NonQualified: 'error',
        },
        defaultVariant: 'info',
      },
    },
    {
      field: 'lookback',
      header: 'Lookback',
      type: 'conditional',
      width: 300,
      align: 'center',
      conditionalValues: { true: 'Yes', false: 'No' },
    },
    {
      field: 'priceRule',
      header: 'Price Rule',
      type: 'text',
      width: 300,
      visibility: 'picker',
    },
    {
      field: 'status',
      header: 'Status',
      type: 'badge',
      width: 300,
      align: 'center',
      badge: {
        statusMap: {
          Approved: 'success',
          Reject: 'error',
          Pending: 'info',
        },
        defaultVariant: 'info',
      },
    },
  ],

  actions: {
    row: [
      { id: 'VIEW_OFFERING_PERIOD_ESPP', label: 'View' },
      { id: 'EDIT_ESPP_OFFERING_PERIOD', label: 'Edit' },
      { id: 'PUBLISH_OFFERING_PERIOD_ESPP', label: 'Publish' },
    ],
    toolbar: {
      primary: {
        id: 'ADD_OFFERING_PERIOD_ESPP',
        label: 'Add Offering Period',
        icon: 'add_circle',
      },
      secondary: [
        {
          label: 'Downloads',
          icon: 'download',
          type: 'download',
          children: [
            { id: 'DOWNLOAD_TEMPLATE_OFFERING_PERIOD_ESPP', label: 'Download Template' },
          ],
        },
        {
          label: 'Import',
          icon: 'upload',
          type: 'upload',
          children: [
            { id: 'IMPORT_OFFERING_PERIOD_ESPP', label: 'Import Bulk XLS' },
          ],
        },
      ],
    },
  },

  features: {
    search: { enabled: false },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    columnPreferences: { persistenceKey: 'ESPP', resizable: true, reorderable: true },
  },
};
